import aboutAnimation from '../animations/about.json';
import Lottie from 'react-lottie-player'

function About() {
	return (
		<div>
			<div className="card about">
				<div className="text__center">
					<Lottie
						loop
						animationData={aboutAnimation}
						play
						style={{ width: 340, margin: 'auto' }}
					/>
				</div>
				<br/>
				<div className="about__inner text__center">
					Find the perfect candidates efficiently and objectively with InterviewAI.
					<br />
					Our advanced AI generates tailored interviews for any job description, ensuring a better assessment of skills.
					<br />
					Score candidate answers accurately based on response quality, relevance, and keywords.
					<br />
					Elevate your hiring process today!"
				</div>
			</div>
		</div>
	)
}

export default About